<template>
  <div class="w-100 px-2 mt-5">
    <v-container fluid class="pt-0 pb-15 d-flex flex-column">
      <!-- Modern Header Section -->
      <div class="header-container">
        <div class="header-content">
          <div class="header-title">
            <span class="white--text font-30 app-medium-font header-text">
              {{ $t("ads") }}
            </span>
            <v-chip class="ml-3" color="#fff" small outlined>
              {{ ads.length }} Active
            </v-chip>
          </div>
          
          <div class="header-actions">
            <v-btn 
              color="#B5E539" 
              depressed
              class="action-btn mr-2"
              @click="onCreatebusiness"
            >
              <v-icon left small>mdi-domain-plus</v-icon>
              Add Business
            </v-btn>
            <v-btn 
              color="#B5E539" 
              depressed
              class="action-btn"
              @click="onCreateAds"
            >
              <v-icon left small>mdi-plus-circle</v-icon>
              Create Ad
            </v-btn>
          </div>
        </div>
        
        <div class="header-divider"></div>
      </div>

      <!-- Cards Grid -->
      <v-row dense>
        <v-col 
          v-for="ad in ads" 
          :key="ad._id"
          cols="12" sm="6" md="4" lg="3"
        >
          <ads-card :ads="ad" />
        </v-col>
      </v-row>

      <!-- Dialogs and Snackbar -->
      <confirm-delete-dialog
        :deleteDialog="deleteDialg"
        :onClose="onCloseConfirmDelete"
        :onConfirm="onConfirmDelete"
      />
      <admin-add-ads-dialog
        :dialog="addDialog"
        :onClose="onCloseDialog"
        v-if="addDialog"
      />
      <admin-add-business-dialog
        :dialog="addBusinessDialog"
        :onClose="onCloseDialog"
        v-if="addBusinessDialog"
      />
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import dateFormat from "dateformat";
import ConfirmDeleteDialog from "@/components/common/ConfirmDeleteDialog.vue";
import AdminAddAdsDialog from "./AdminAddAdsDialog.vue";
import AdsCard from "@/components/ads/AdsCard.vue";
import AdminAddBusinessDialog from "./AdminAddBusinessDialog.vue";
export default {
  components: {
    ConfirmDeleteDialog,
    AdminAddAdsDialog,
    AdminAddBusinessDialog,
    AdsCard
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "", value: "image" },
        { text: "Name", value: "name" },
        { text: "About", value: "about" },
        { text: "Website", value: "website" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions" }
      ],
      deleteDialg: false,
      selected: null,
      expanded: [],
      editDialog: false,
      addDialog: false,
      addBusinessDialog: false,
      snackbar: false,
      errorMessage: null
    };
  },
  methods: {
    ...mapActions("ads", {
      fetchAllAds: "fetchAllAds",
      deleteAds: "deleteAds"
    }),
    onSelectClient(item) {
      console.log(item);
    },
    formatDate(date) {
      return dateFormat(this.convertTZ(date, this.timezone), "mm/dd/yyyy");
    },
    convertTZ(date, tzString) {
      if (!date) return "";
      return new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString(
          "en-US",
          {
            timeZone: tzString ? tzString : "America/New_York"
          }
        )
      );
    },
    onEditAds(item) {
      this.selected = item;
      this.editDialog = true;
    },
    onCloseDialog() {
      this.addDialog = false;
      this.editDialog = false;
      this.addBusinessDialog = false;
    },
    onDeleteAds(item) {
      this.selected = item;
      this.deleteDialg = true;
    },
    onCloseConfirmDelete() {
      this.deleteDialg = false;
    },
    onConfirmDelete() {
      this.deleteDialg = false;
      this.loading = true;
      this.deleteAds({ _id: this.selected._id })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    onCreateAds() {
      this.addDialog = true;
    },
    onCreatebusiness() {
      this.addBusinessDialog = true;
    }
  },
  computed: {
    ...mapGetters({
      ads: "ads/getAllAds",
      profile: "auth/getProfile",
      profileType: "auth/getType",
      timezone: "usersetting/getTimeZone"
    })
  },
  mounted() {
    if (this.profileType != "Admin") {
      this.$router.push({ name: "home" });
    }
    this.loading = true;
    const payload = {
      type: this.$route.query.type || "all"
    };
    this.fetchAllAds(payload)
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        if (error.response == undefined) {
          console.log(error);
        } else {
          this.showErrorMessage(error.response.data.message);
        }
      });
  }
};
</script>


<style scoped>
/* Modern Header Styles */
.header-container {
  margin-bottom: 24px;
  padding: 0 16px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
}

.header-title {
  display: flex;
  align-items: center;
}

.header-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: relative;
}

.header-text::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, #B5E539, #6c5ce7);
  border-radius: 3px;
}

.header-actions {
  display: flex;
  align-items: center;
}

.action-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.3);
}

.header-divider {
  height: 1px;
  background: linear-gradient(90deg, rgba(108, 92, 231, 0.3), rgba(108, 92, 231, 0));
}

/* Cards Grid Styles */
.v-col {
  padding: 12px !important;
  transition: transform 0.3s ease;
}

.v-col:hover {
  transform: translateY(-4px);
}

.ads-card {
  height: 100%;
  transition: all 0.3s ease;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .header-actions {
    margin-top: 16px;
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .header-text {
    font-size: 24px;
  }
  
  .header-actions {
    flex-direction: column;
    align-items: flex-end;
  }
  
  .action-btn {
    margin-bottom: 8px;
    width: 100%;
    max-width: 200px;
  }
  
  .v-col {
    padding: 8px !important;
  }
}
</style>